/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sendingmagiclink2Inputs */

const zh_auth_sendingmagiclink2 = /** @type {(inputs: Auth_Sendingmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中...`)
};

const en_auth_sendingmagiclink2 = /** @type {(inputs: Auth_Sendingmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const es_auth_sendingmagiclink2 = /** @type {(inputs: Auth_Sendingmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Auth_Sendingmagiclink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_sendingmagiclink2 = /** @type {((inputs?: Auth_Sendingmagiclink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sendingmagiclink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_sendingmagiclink2(inputs)
	if (locale === "en") return en_auth_sendingmagiclink2(inputs)
	return es_auth_sendingmagiclink2(inputs)
});
export { auth_sendingmagiclink2 as "auth_sendingMagicLink" }